import React, { useMemo } from "react";

function ChatContacts({ handleContactClick, data }) {
  // Function to sort contacts by the latest message time
  const sortedContacts = useMemo(() => {
    const contacts = Array.isArray(data) ? data : data?.data || [];
    return contacts.slice().sort((a, b) => {
      const getLatestTime = (messages = []) =>
        messages.length > 0
          ? Math.max(
              ...messages.map((msg) => new Date(msg.updated_at).getTime())
            )
          : 0;

      return getLatestTime(b.messages) - getLatestTime(a.messages);
    });
  }, [data]);

  return (
    <ul className="text-gray-800">
      {sortedContacts.map((contact) => {
        const unreadMessages = contact?.messages?.filter(
          (msg) => msg.role === "receiver" && Number(msg?.is_read) === 0
        ).length;

        return (
          <li
            key={contact?.id}
            className="py-2 px-1 hover:bg-gray-200 cursor-pointer rounded"
            onClick={() => handleContactClick(contact?.id, contact?.firstname)}
          >
            <h2 className="flex gap-2 items-center justify-between">
              {contact?.firstname}
              {unreadMessages > 0 && (
                <span className="text-[8px] p-1 w-3 h-3 bg-green-500 rounded-full flex justify-center items-center text-white">
                  {unreadMessages}
                </span>
              )}
            </h2>
          </li>
        );
      })}
    </ul>
  );
}

export default ChatContacts;
